<template>
  <div class="content">
    <a-tabs :default-active-key="defaultActive" style="width: 100%">
      <a-tab-pane :key="1" tab="成绩统计">
        <div class="history">
          <div class="list">
            <div class="headline hasExplain">
              <span>成绩各等级趋势</span>
              <img
                src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_60e58e5c39fc1/323827104.png"
                @click="showExplan = !showExplan"
                alt=""
              />
              <div v-if="showExplan">
                <img
                  src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_60e5904cc1fba/204815583.png"
                  alt=""
                />
                <span>优秀率：获得A成绩所占比例</span>
                <span>良好率：获得A和B成绩所占比例</span>
                <span>及格率：获得A、B和C成绩所占比例</span>
                <span>不及格率：获得D成绩所占比例</span>
              </div>
            </div>
            <div>
              <Screen
                :showSelect="[400, 3, 202, 201]"
                @dateChange="schoolResultLevel"
              ></Screen>
            </div>
            <div class="echarts">
              <div class="echarts" id="grade"></div>
              <NoData :show.sync="noDataShow1"></NoData>
            </div>
          </div>
          <div class="list">
            <div class="headline">专业成绩趋势</div>
            <div>
              <Screen
                :showSelect="[400, 1, 2, 3, 201]"
                @dateChange="schoolResultLevelSubject"
              ></Screen>
            </div>
            <div class="echarts">
              <div class="echarts" id="subject"></div>
              <NoData :show.sync="noDataShow2"></NoData>
            </div>
          </div>
          <div class="list">
            <div class="headline">
              <span>专业成绩排名</span>
            </div>
            <div class="content">
              <div class="tableHealine">
                <div>排名</div>
                <div>班级</div>
                <div>及格率</div>
                <div>排名</div>
                <div>班级</div>
                <div>及格率</div>
                <div>排名</div>
                <div>班级</div>
                <div>及格率</div>
              </div>
              <div class="tableContent">
                <template v-for="(item, index) of topData">
                  <div :key="index">{{ index + 1 }}</div>
                  <div :key="index">{{ item.class_name }}</div>
                  <div :key="index">{{ item.percent }}%</div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import NoData from "./noData.vue";
import Screen from "./screen.vue";
import echarts from "echarts";
import { echartsConfig } from "./customed.js";
echartsConfig({}, echarts);
console.log(echarts);
export default {
  components: {
    NoData,
    Screen,
  },
  data() {
    return {
      defaultActive: 1,
      gradeData: {},
      subjectData: {},
      topData: [],
      noDataShow1: false,
      noDataShow2: false,
      showExplan: false,
    };
  },
  props: {
    title: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    // 获取成绩各等级趋势 数据
    schoolResultLevel(selectData) {
      this.gradeData = {
        date: [
          20231004,
          20231005,
          20231006,
          20231007,
          20231008,
          20231009,
          20231010,
          20231011,
          20231012,
          20231013,
          20231014,
          20231015,
          20231016,
          20231017,
          20231018,
          20231019,
          20231020,
          20231021,
          20231022,
          20231023,
          20231024,
          20231025,
          20231026,
          20231027,
          20231028,
          20231029,
          20231030,
          20231031,
          20231101,
          20231102,
          20231103,
          20231104,
          20231105,
          20231106,
          20231107,
          20231108,
          20231109,
          20231110,
          20231111,
          20231112,
          20231113,
          20231114,
          20231115,
          20231116,
          20231117,
          20231118,
          20231119,
          20231120,
          20231121,
          20231122,
          20231123,
          20231124,
          20231125,
          20231126,
          20231127,
          20231128,
          20231129,
          20231130,
          20231201,
          20231202,
          20231203,
          20231204,
          20231205,
          20231206,
          20231207,
          20231208,
          20231209,
          20231210,
          20231211,
          20231212,
          20231213,
          20231214,
          20231215,
          20231216,
          20231217,
          20231218,
          20231219,
          20231220,
          20231221,
          20231222
        ],
        list: [
          {
            class_id: "214",
            class_name: "机电一班",
            percent: this.generateRandomNumbers(86, 95, 98),
          },
          {
            class_id: "212",
            class_name: "机电二班",
            percent: this.generateRandomNumbers(86, 83, 96),
          },
          {
            class_id: "213",
            class_name: "机电三班",
            percent: this.generateRandomNumbers(86, 75, 90),
          },
          {
            class_id: "213",
            class_name: "机电四班",
            percent: this.generateRandomNumbers(86, 70, 87),
          },
          {
            class_id: "213",
            class_name: "机电五班",
            percent: this.generateRandomNumbers(86, 55, 73),
          },
          {
            class_id: "213",
            class_name: "机电六班",
            percent: this.generateRandomNumbers(86, 45, 60),
          },
        ],
      };
      console.log(echarts);
      this.gradeEcharts();
    },
    // 获取专业成绩趋势
    schoolResultLevelSubject(selectData) {
      const res = {
        date: [
          20231004,
          20231005,
          20231006,
          20231007,
          20231008,
          20231009,
          20231010,
          20231011,
          20231012,
          20231013,
          20231014,
          20231015,
          20231016,
          20231017,
          20231018,
          20231019,
          20231020,
          20231021,
          20231022,
          20231023,
          20231024,
          20231025,
          20231026,
          20231027,
          20231028,
          20231029,
          20231030,
          20231031,
          20231101,
          20231102,
          20231103,
          20231104,
          20231105,
          20231106,
          20231107,
          20231108,
          20231109,
          20231110,
          20231111,
          20231112,
          20231113,
          20231114,
          20231115,
          20231116,
          20231117,
          20231118,
          20231119,
          20231120,
          20231121,
          20231122,
          20231123,
          20231124,
          20231125,
          20231126,
          20231127,
          20231128,
          20231129,
          20231130,
          20231201,
          20231202,
          20231203,
          20231204,
          20231205,
          20231206,
          20231207,
          20231208,
          20231209,
          20231210,
          20231211,
          20231212,
          20231213,
          20231214,
          20231215,
          20231216,
          20231217,
          20231218,
          20231219,
          20231220,
          20231221,
        ],
        list: [
          {
            class_id: "214",
            class_name: "机电一班",
            percent: this.generateRandomNumbers(86, 95, 98),
          },
          {
            class_id: "212",
            class_name: "机电二班",
            percent: this.generateRandomNumbers(86, 83, 96),
          },
          {
            class_id: "213",
            class_name: "机电三班",
            percent: this.generateRandomNumbers(86, 75, 90),
          },
          {
            class_id: "213",
            class_name: "机电四班",
            percent: this.generateRandomNumbers(86, 70, 87),
          },
          {
            class_id: "213",
            class_name: "机电五班",
            percent: this.generateRandomNumbers(86, 55, 73),
          },
          {
            class_id: "213",
            class_name: "机电六班",
            percent: this.generateRandomNumbers(86, 45, 60),
          },
        ],
        top: [
          {
            class_id: "212",
            class_name: "机电一班",
            percent: 93,
          },
          {
            class_id: "214",
            class_name: "机电二班",
            percent: 87,
          },
          {
            class_id: "213",
            class_name: "机电三班",
            percent: 81,
          },
          {
            class_id: "212",
            class_name: "机电四班",
            percent: 79,
          },
          {
            class_id: "214",
            class_name: "机电五班",
            percent: 63,
          },
          {
            class_id: "213",
            class_name: "机电六班",
            percent: 50,
          },
        ],
      };
      this.subjectData = res;
      this.topData = res.top;
      this.subjectEcharts();
    },
    // 成绩等级统计
    gradeEcharts() {
      const chart = echarts.init(document.getElementById("grade"), "customed");
      chart.clear();
      const typeList = [];
      const series = [];
      this.gradeData.list.forEach((element) => {
        typeList.push(element.class_name);
        series.push({
          name: element.class_name,
          type: "line",
          data: element.percent,
        });
      });

      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: (params) => {
            let templete = "";
            for (const every of params) {
              const item = every;
              if (item.seriesType === "line") {
                templete += item.seriesName + `: ` + item.data + "%" + "<br>";
              } else {
                templete += item.seriesName + `: ` + item.data + "<br>";
              }
            }
            return templete;
          },
        },
        legend: {
          data: typeList,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: this.gradeData.date,
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              formatter: "{value}%",
            },
          },
        ],
        series,
      };
      chart.setOption(option);
      setTimeout(() => {
        chart.resize();
      }, 100);
    },
    subjectEcharts() {
      const chart = echarts.init(document.getElementById("subject"), "customed");
      chart.clear();
      const typeList = [];
      const series = [];
      this.subjectData.list.forEach((element) => {
        typeList.push(element.class_name);
        series.push({
          name: element.class_name,
          type: "bar",
          data: element.percent,
        });
      });
      // console.log(series)

      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: (params) => {
            let templete = "";
            for (const every of params) {
              const item = every;
              if (item.seriesType === "line") {
                templete += item.seriesName + `: ` + item.data + "%" + "<br>";
              } else {
                templete += item.seriesName + `: ` + item.data + "<br>";
              }
            }
            return templete;
          },
        },
        legend: {
          data: typeList,
          selected: {
            机电一班: false,
            机电三班: false,
            机电四班: false,
            机电五班: false,
            机电六班: false,
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: this.subjectData.date,
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              formatter: "{value}%",
            },
          },
        ],
        series,
      };
      chart.setOption(option);
      setTimeout(() => {
        chart.resize();
      }, 100);
    },
    generateRandomNumbers(count, min, max) {
      const numbers = [];
      for (let i = 0; i < count; i++) {
        const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
        numbers.push(randomNumber);
      }
      return numbers;
    }
  },
  mounted() {
    setTimeout(() => {
      this.schoolResultLevel();
      this.schoolResultLevelSubject()
    }, 100);
  },
};
</script>

<style scoped lang="less">
.content {
  padding: 20px;
  height: 100%;
  overflow-y: auto;
}
.list {
  width: 100%;
  height: auto;
  background: #fff;
  margin-top: 12px;
  box-sizing: border-box;
  .headline {
    width: 100%;
    height: 52px;
    background: rgba(237, 242, 246, 0.35);
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 500;
    color: rgba(23, 23, 23, 0.85);
  }
  .hasExplain {
    justify-content: flex-start;
    position: relative;
    > img {
      width: 15px;
      cursor: pointer;
      margin-left: 12px;
    }
    > div {
      position: absolute;
      top: 40px;
      left: 120px;
      width: 213px;
      height: 116px;
      padding: 15px 0 0 9px;
      box-sizing: border-box;
      z-index: 10;
      box-shadow: 5px 5px 10px #f3f3f3;
      img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
      }
      span {
        display: block;
        font-size: 12px;
        font-weight: 400;
        color: #6d819c;
        line-height: 21px;
      }
    }
  }
  .content {
    padding: 20px;
    .tableHealine {
      width: 100%;
      height: 40px;
      background: #edf2f6;
      display: flex;
      > div {
        border-bottom: 1px solid #dbe6ee;
        border-right: 1px solid #dbe6ee;
        border-top: 1px solid #dbe6ee;
        font-size: 14px;
        font-weight: 400;
        color: #272727;
        line-height: 40px;
        text-align: center;
      }
      > div:nth-child(9n - 8) {
        border-left: 1px solid #dbe6ee;
      }
      > div:nth-child(3n-1) {
        width: 10%;
      }
      > div:nth-child(3n-2) {
        width: 10%;
      }
      > div:nth-child(3n) {
        width: 13.33%;
      }
    }
    .tableContent {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      > div {
        font-size: 14px;
        font-weight: 400;
        color: #171717;
        line-height: 40px;
        border-bottom: 1px solid #dbe6ee;
        border-right: 1px solid #dbe6ee;
        text-align: center;
      }
      > div:nth-child(1),
      > div:nth-child(2),
      > div:nth-child(3) {
        color: #eb633c;
      }
      > div:nth-child(4),
      > div:nth-child(5),
      > div:nth-child(6) {
        color: #b16c5c;
      }
      > div:nth-child(7),
      > div:nth-child(8),
      > div:nth-child(9) {
        color: #3c6b9d;
      }
      > div:nth-child(9n - 8) {
        border-left: 1px solid #dbe6ee;
      }
      > div:nth-child(3n-2) {
        width: 10%;
      }
      > div:nth-child(3n-1) {
        width: 10%;
      }
      > div:nth-child(3n) {
        width: 13.333%;
      }
    }
  }
  .echarts {
    width: 100%;
    height: 290px;
    position: relative;
  }
}
</style>
